// KEEP IN SYNC with src/server/modules/common/platformUrl.js
// (CRA blocks cross-src imports — see CLAUDE.md "UI sync" pattern)

export const PLATFORM_HOSTS: Record<string, string[]> = {
  eventim: ['ticketone.it', 'eventim.de', 'eventim.co.uk', 'eventim.com', 'eventim.ch', 'ticketcorner.ch', 'entradas.com'],
  ticketmaster: ['ticketmaster.it', 'ticketmaster.de', 'ticketmaster.es', 'ticketmaster.co.uk', 'ticketmaster.ch'],
  vivaticket: ['vivaticket.com', 'vivaticket.it'],
  vivaresale: ['vivaticket.com', 'vivaticket.it'],
  fansale: ['fansale.it', 'fansale.de', 'fansale.es', 'fansale.co.uk', 'fansale.ch'],
  fansaleEvent: ['fansale.it', 'fansale.de', 'fansale.es', 'fansale.co.uk', 'fansale.ch']
}

const matchHost = (hostname: string, suffixes: string[]): boolean => {
  for (const s of suffixes) {
    if (hostname === s || hostname.endsWith('.' + s)) return true
  }
  return false
}

export const detectPlatform = (url: string): string | null => {
  let parsed: URL
  try { parsed = new URL(url) } catch (e) { return null }
  const host = parsed.hostname
  if (matchHost(host, PLATFORM_HOSTS.ticketmaster)) return 'ticketmaster'
  if (matchHost(host, PLATFORM_HOSTS.eventim)) return 'eventim'
  if (matchHost(host, PLATFORM_HOSTS.vivaticket)) {
    return /resell|Rivendita/.test(url) ? 'vivaresale' : 'vivaticket'
  }
  if (matchHost(host, PLATFORM_HOSTS.fansale)) return 'fansale'
  return null
}

// Returns null if valid, error message string if not.
export const checkPlatformUrl = (url: string, platform: string): string | null => {
  let parsed: URL
  try {
    parsed = new URL(url)
  } catch (e) {
    return 'URL non valido (formato)'
  }
  const hosts = PLATFORM_HOSTS[platform]
  if (!hosts) return null
  if (!matchHost(parsed.hostname, hosts)) {
    return `URL non valido per ${platform}: hostname "${parsed.hostname}" non è in whitelist (atteso: ${hosts.join(', ')})`
  }
  if (platform === 'vivaresale' && !/resell|Rivendita/.test(url)) {
    return 'URL vivaresale deve contenere il marker "resell" o "Rivendita"'
  }
  if (platform === 'vivaticket' && /resell|Rivendita/.test(url)) {
    return 'URL vivaticket non deve essere un URL di rivendita — usa vivaresale'
  }
  return null
}
